export default defineNuxtRouteMiddleware(async () => {
  const { userAgentState } = useUserAgentState();

  if (userAgentState.value === '') {
    const ua = useRequestHeader('user-agent');
    userAgentState.value = ua ?? '';
  }
});
